
import LogoCloud from '~/components/global/LogoCloud'
import Faq from '~/components/global/Faq'
import Callout from '~/components/global/Callout'
import Breadcrumbs from '~/components/Breadcrumbs'
import AggregateRating from '~/components/AggregateRating'
import CtaHero from '~/components/global/CtaHero.vue'
import Steps from '~/components/global/Steps.vue'
import Testimonial from '~/components/global/Testimonial.vue'
import Articles from '~/components/global/Articles.vue'
import Features from '~/components/global/Features.vue'
import Gallery from '~/components/global/Gallery.vue'
import Youtube from '~/components/global/Youtube.vue'
import RelatedArticles from '~/components/global/RelatedArticles.vue'

export default {
  name: 'CompomentLoader',
  components: { Youtube, RelatedArticles, Gallery, Features, Articles, Testimonial, Steps, CtaHero, Breadcrumbs, Callout, Faq, LogoCloud, AggregateRating },
  props: {
    page: {},
  },
}
